import { createFeatureSelector, createSelector } from '@ngrx/store';
import { AppState } from '../../store';
import { PigState } from './pig.reducer';

export const selectPig = createFeatureSelector<AppState, PigState>('pig');

export const selectPigFunctions = createSelector(selectPig, (state: PigState) => state.functions);
